export const ENUM_MODES_MODAL = {
  CREATE: 'create',
  EDIT_STORES: 'edit-stores',
  EDIT_PRODUCTION_PLANNING: 'edit-prodution-planning',
  EDIT_PRODUCTION_PLANNING_FROM_STORE: 'edit-prodution-planning-from-store',
  ENABLE_PRODUCT: 'enable-product',
};

export default ENUM_MODES_MODAL;
